import { AxiosInstance } from 'axios';

const SubscriptionServiceFactory = ({ HTTPBase }: { HTTPBase: AxiosInstance }) => {
  return {
    getAppSubscribtionExpiration: (appId: number): Promise<Date> =>
      HTTPBase.get(`apps/${appId}/expiredAt`).then((res) => new Date(res.data)),
  };
};

export default SubscriptionServiceFactory;
